//REACT
import React, { useEffect, useState } from 'react';

//REDUX
import {useDispatch, useSelector} from "react-redux";
import {setDashBoardIsActive, setSearchIsActive, setSearchTerm} from "../../../Features/Misc/activeSlice";
import {setWatchIsActive, setReadIsActive, setLearnIsActive} from "../../../Features/Misc/navBarSlice";

//ANIMATE
import {Animate} from "react-simple-animate";

//COMPONENTS
import Footer from "../../Components/Footer";
import Loader from "../../Components/Loader";
// import LandingWelcomeBar from "./LandingWelcomeBar";
// import LandingBrandingBar from "./LandingBrandingBar";
// import LandingButton from "./LandingButton";


import LandingHeader from "./DevLandingHeader";
import LandingTitle from "./DevLandingTitle";
import LandingCard from "./DevLandingCard";


export default function DevLanding(props) {

    const { watchesIsPending } = useSelector((state) => state.watches)
    const { readsIsPending } = useSelector((state) => state.reads)
    const { learnsIsPending } = useSelector((state) => state.learns)
    const { hasActiveSubscription   } = useSelector(state => state.auth)

    const dispatch = useDispatch()
    const isLoading = hasActiveSubscription && (watchesIsPending || readsIsPending || learnsIsPending);
    const [playAnimation, setPlayAnimation] = useState(false);


    const takeMeToMyResult = (term) =>{
        // dispatch(setDashBoardIsActive()) testing taking this out
        // dispatch(setWatchIsActive()) testing taking this out
        dispatch(setSearchIsActive())
        dispatch(setSearchTerm(term))
    }


    const [isLoaded, setIsLoaded] = useState(false);


    useEffect(() => {
        // This will only set isLoaded to true if hasActiveSubscription is a boolean
        if (hasActiveSubscription === 'active') {
            setIsLoaded(true);
        }
    }, [hasActiveSubscription]);

    useEffect(() => {
        if (!isLoading && isLoaded) {

            setTimeout(() => {
                setPlayAnimation(true);
            }, 150);
        }
    }, [isLoading, isLoaded]);

    return (
        <>
            <LandingHeader />
            <LandingTitle />

            <div className="Landing mb-12">

                { isLoading && <Loader type={"gold"} /> }

                {!isLoading && isLoaded && (

                    <Animate play={playAnimation} start={{ opacity: 0 }} end={{ opacity: 1 }} duration={0.7}>
                        {hasActiveSubscription && (
                            <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3 mb-12">
                                <LandingCard type="1" job={() => takeMeToMyResult("can’t sleep")} />
                                <LandingCard type="2"  job={() => takeMeToMyResult("waking in the night")} />
                                <LandingCard type="3"  job={() => takeMeToMyResult("temperature")} />
                                <LandingCard type="4"  job={() => takeMeToMyResult("snoring")} />
                                <LandingCard type="5"  job={() => takeMeToMyResult("menopause")} />
                                <LandingCard type="6"  job={() => takeMeToMyResult("shift work")} />
                            </div>
                        )}

                        {hasActiveSubscription === false && (
                            <LandingCard type="inactive" />
                        )}
                    </Animate>

                )}


                <Animate
                    play
                    start={{opacity: 0}}
                    end={{
                        opacity: 1,
                        gridRowStart: 24,
                        gridRowEnd: 25,
                        fontSize: "0.875rem",
                        gridColumnStart: 1,
                        gridColumnEnd: 25
                    }}
                >
                    <Footer className={`text-xs lg:text-base flex justify-center text-white `}/>
                </Animate>
            </div>
        </>
    );
}
